var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.checked)?_c('font-awesome-icon',{attrs:{"icon":['far', 'check-square'],"size":"lg"}}):_c('font-awesome-icon',{attrs:{"icon":['far', 'square'],"size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }